import { Loader2 } from "lucide-react";

export const PageHeader = ({ title, subtitle, action, testId }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4" data-testid={testId}>
    <div>
      <h1 className="font-heading text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-gray-400">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Card = ({ children, className = "", ...props }) => (
  <div
    className={`rounded-2xl border border-[#27272A] bg-[#141416] p-4 shadow-lg transition-colors sm:p-6 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const Stat = ({ label, value, hint, accent, testId }) => (
  <div
    className="rounded-2xl border border-[#27272A] bg-[#141416] p-5 shadow-lg"
    data-testid={testId}
  >
    <div className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</div>
    <div
      className="mt-2 font-heading text-2xl font-extrabold tracking-tight sm:text-3xl"
      style={{ color: accent || "#fff" }}
    >
      {value}
    </div>
    {hint && <div className="mt-1 text-xs text-gray-500">{hint}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action, testId }) => (
  <div
    className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-[#27272A] bg-[#101012] px-6 py-14 text-center"
    data-testid={testId}
  >
    {Icon && (
      <div className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-[#18181B] text-[#FF6A00]">
        <Icon size={26} />
      </div>
    )}
    <div className="font-heading text-lg font-bold text-white">{title}</div>
    {subtitle && <div className="mt-1 max-w-sm text-sm text-gray-400">{subtitle}</div>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const Loader = ({ label = "Cargando…" }) => (
  <div className="flex items-center justify-center gap-3 py-16 text-gray-400" data-testid="loader">
    <Loader2 className="animate-spin text-[#FF6A00]" size={22} />
    <span className="text-sm">{label}</span>
  </div>
);

export const EstimacionBadge = () => (
  <span
    className="inline-flex items-center gap-1.5 rounded-full border border-[#FF6A00] bg-[#FF6A00]/15 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-[#FF6A00]"
    data-testid="estimacion-badge"
    title="Distancia en línea recta (estimación de desarrollo). No es distancia real por carretera."
  >
    Estimación
  </span>
);
